import React from 'react';
import type { Fixture } from '../../services/TennisLiveApi';

interface TennisMatchCardProps {
  fixture: Fixture;
  onClick?: () => void;
}

export const TennisMatchCard: React.FC<TennisMatchCardProps> = ({ fixture, onClick }) => {
  const safeStatus = String(fixture.status || '');
  const isLive = safeStatus.includes('🔴') || safeStatus.toLowerCase().includes('set');
  const statusText = safeStatus.replace('🔴 ', '');

  return (
    <div 
      onClick={onClick}
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        color: '#0f172a'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '11px', fontWeight: 'bold' }}>
        <span style={{ color: isLive ? '#ef4444' : '#64748b', display: 'flex', alignItems: 'center', gap: '4px' }}>
          {isLive && <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#ef4444' }} />}
          {statusText}
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {/* Home Player */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 }}>
            {Array.isArray(fixture.homePlayer.country) ? (
              fixture.homePlayer.country.map((flag, idx) => {
                const nameParts = fixture.homePlayer.name.split('/');
                return (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                    {flag && <img src={flag} alt="flag" style={{ width: '16px', height: '11px', objectFit: 'cover', borderRadius: '2px', border: '1px solid #cbd5e1', flexShrink: 0 }} />}
                    <span style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {nameParts[idx]?.trim()}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                {fixture.homePlayer.country && (
                  <img src={fixture.homePlayer.country as string} alt="flag" style={{ width: '16px', height: '11px', objectFit: 'cover', borderRadius: '2px', border: '1px solid #cbd5e1', flexShrink: 0 }} />
                )}
                <span style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {fixture.homePlayer.name}
                </span>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px', minWidth: '80px', justifyContent: 'flex-end', fontWeight: 'bold', fontSize: '14px', color: '#334155' }}>
            {fixture.score.home.map((s, i) => (
              <span key={i} style={{ width: '12px', textAlign: 'center' }}>{s}</span>
            ))}
            {fixture.score.liveGameScore && fixture.score.liveGameScore.includes('-') && (
              <span style={{ color: '#ef4444', marginLeft: '4px', minWidth: '16px', textAlign: 'right' }}>{fixture.score.liveGameScore.split('-')[0].trim()}</span>
            )}
          </div>
        </div>

        {/* Away Player */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: Array.isArray(fixture.homePlayer.country) ? '4px' : '0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 }}>
            {Array.isArray(fixture.awayPlayer.country) ? (
              fixture.awayPlayer.country.map((flag, idx) => {
                const nameParts = fixture.awayPlayer.name.split('/');
                return (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                    {flag && <img src={flag} alt="flag" style={{ width: '16px', height: '11px', objectFit: 'cover', borderRadius: '2px', border: '1px solid #cbd5e1', flexShrink: 0 }} />}
                    <span style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {nameParts[idx]?.trim()}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                {fixture.awayPlayer.country && (
                  <img src={fixture.awayPlayer.country as string} alt="flag" style={{ width: '16px', height: '11px', objectFit: 'cover', borderRadius: '2px', border: '1px solid #cbd5e1', flexShrink: 0 }} />
                )}
                <span style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {fixture.awayPlayer.name}
                </span>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px', minWidth: '80px', justifyContent: 'flex-end', fontWeight: 'bold', fontSize: '14px', color: '#334155' }}>
            {fixture.score.away.map((s, i) => (
              <span key={i} style={{ width: '12px', textAlign: 'center' }}>{s}</span>
            ))}
            {fixture.score.liveGameScore && fixture.score.liveGameScore.includes('-') && (
              <span style={{ color: '#ef4444', marginLeft: '4px', minWidth: '16px', textAlign: 'right' }}>{fixture.score.liveGameScore.split('-')[1].trim()}</span>
            )}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '12px', fontSize: '11px', color: '#94a3b8' }}>
        {fixture.round || 'Rodada Atual'}
      </div>
    </div>
  );
};
